import api from "../../api";

class AuthApi {
  static checkAuth() {
    return api.get("/user/current");
  }

  static login(body) {
    return api.post("/user/login", body);
  }

  static register(body) {
    return api.post("/user", body);
  }
}

export default AuthApi;
